import Packery from "packery";

document.addEventListener("DOMContentLoaded", () => {
  const elem = document.querySelector(".js-grid-list");
  if (!elem) return;

  new Packery(elem, {
    itemSelector: ".js-grid-item",
    gutter: 10,
  });
});